import React, { useEffect, useState } from "react";
import "./PaymentMethodsMenu.scss";
import { useStore } from "../../../hooks/store";
import MenuItem from "../../../atoms/AgrofyPay/MenuItem/MenuItem";
import { Text } from "agrofy-ui-components";
import Divider from "../../../atoms/Divider/Divider";

const PaymentMethodsMenu = (props) => {
  const [state, dispatch] = useStore();
  const [paymentMethodsCategories, setPaymentMethodsCategories] =
    useState(null);

  useEffect(() => {
    setPaymentMethodsCategories(state.paymentMethods);
  }, [state.paymentMethods]);

  return (
    <div className="menuContainer">
      {paymentMethodsCategories
        ? paymentMethodsCategories.map((category, index) => {
            return (
              <span key={index}>
                <div className="categoryName">
                  <Text type="heading-xs" color="gray9" tag="h2" className={"m-0"}>
                    {category.Name}
                  </Text>
                </div>
                <div className="itemsContainer">
                  {category.PaymentMethodTypes?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={[
                          index % 2 == 0 ? "marginEnd" : "marginStart",
                          "itemContainer",
                        ].join(" ")}
                      >
                        <MenuItem item={item} category={category}></MenuItem>
                      </div>
                    );
                  })}
                </div>
                {index < paymentMethodsCategories.length - 1 ? (
                  <Divider />
                ) : null}
              </span>
            );
          })
        : null}
    </div>
  );
};

export default PaymentMethodsMenu;
